var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"mx-auto my-auto"},[_c('Logo'),_c('Search'),_c('Git')],1)}
var staticRenderFns = []

export { render, staticRenderFns }